import LAYOUT from '@/layout/layout';
import moduleLayout from '@/modules/RegisteredUsers/layout/Layout.vue';

export default [
  {
    path: '/registered_users',
    component: LAYOUT.base,
    redirect: '/registered_users/users',
    children: [
      {
        path: 'users',
        component: moduleLayout,
        children: [
          {
            path: '',
            name: 'RegisteredUsers',
            component: () => import(/* webpackChunkName: 'registered-users-users' */ '@/modules/RegisteredUsers/views/UsersTab.vue'),
          },
        ],
      },
    ],
  },
];
